(() => {
  const initialized = new WeakSet();
  const mobileLayout = window.matchMedia('(max-width: 739px)');
  const footerMenus = new WeakSet();
  function initFooter() {
    if (!document.body.classList.contains('template-index')) return;
    document.querySelectorAll('#footer .footer-menu').forEach((block, index) => {
      if (footerMenus.has(block)) return;
      const heading = block.querySelector('h3');
      const links = block.querySelector('ul');
      if (!heading || !links) return;
      footerMenus.add(block);
      const label = document.createElement('span');
      label.textContent = heading.textContent;
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'ac-home-footer-toggle';
      toggle.textContent = heading.textContent;
      links.id ||= `ac-home-footer-links-${index}`;
      toggle.setAttribute('aria-controls', links.id);
      toggle.setAttribute('aria-expanded', 'false');
      heading.replaceChildren(label, toggle);
      function sync() {
        label.hidden = mobileLayout.matches;
        toggle.hidden = !mobileLayout.matches;
        links.hidden = mobileLayout.matches && toggle.getAttribute('aria-expanded') !== 'true';
      }
      toggle.addEventListener('click', () => {
        toggle.setAttribute('aria-expanded', String(toggle.getAttribute('aria-expanded') !== 'true'));
        sync();
      });
      mobileLayout.addEventListener('change', sync);
      sync();
    });
  }
  function randomizeStories(root) {
    root.querySelectorAll('[data-random-story]').forEach(story => {
      const photo = story.querySelector('.ac-ritual__story-photo, .ac-ritual__gift-photo');
      const options = [...story.querySelectorAll('[data-story-image]')];
      if (!photo || !options.length) return;
      const selected = options[Math.floor(Math.random() * options.length)];
      const image = new Image();
      image.alt = selected.dataset.storyAlt;
      image.decoding = 'async';
      image.onload = () => { if (story.isConnected) photo.replaceChildren(image); };
      image.src = selected.dataset.storyImage;
    });
  }
  function randomizeHero(root) {
    const photo = root.querySelector('.ac-ritual__feature-photo');
    const images = [...new Set([...root.querySelectorAll('[data-ritual-hero-products] [data-hero-image]')].map(item => item.dataset.heroImage).filter(Boolean))];
    if (!photo || !images.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = '';
    let nextImage;
    let timer;
    let cleanupTimer;
    function preloadNext() {
      const choices = images.filter(src => src !== current);
      if (!choices.length) return;
      const image = new Image();
      image.alt = '';
      image.decoding = 'async';
      image.src = choices[Math.floor(Math.random() * choices.length)];
      nextImage = image;
    }
    function showNext() {
      if (!root.isConnected) {
        clearInterval(timer);
        clearTimeout(cleanupTimer);
        return;
      }
      if (document.hidden || !nextImage?.complete) return;
      if (!nextImage.naturalWidth) {
        preloadNext();
        return;
      }
      const image = nextImage;
      const previous = [...photo.children];
      current = image.getAttribute('src');
      image.classList.add('ac-ritual__hero-slide--entering');
      photo.append(image);
      requestAnimationFrame(() => requestAnimationFrame(() => {
        image.classList.remove('ac-ritual__hero-slide--entering');
      }));
      cleanupTimer = setTimeout(() => previous.forEach(node => node.remove()), 850);
      preloadNext();
    }
    preloadNext();
    // A static random image respects visitors who prefer reduced motion.
    const firstImage = nextImage;
    function startRotation() {
      if (!root.isConnected) return;
      if (firstImage.naturalWidth) {
        current = firstImage.getAttribute('src');
        photo.replaceChildren(firstImage);
      }
      preloadNext();
      if (images.length > 1 && !reducedMotion.matches) {
        timer = setInterval(() => {
          if (reducedMotion.matches && root.isConnected) return;
          showNext();
        }, 3000);
      }
    }
    if (firstImage.complete) startRotation();
    else {
      firstImage.onload = startRotation;
      firstImage.onerror = startRotation;
    }
  }
  function init(scope) {
    const roots = scope.matches?.('[data-ritual-home]')
      ? [scope] : scope.querySelectorAll('[data-ritual-home]');
    roots.forEach((root) => {
      if (initialized.has(root)) return;
      initialized.add(root);
      // Shopify collection product drops must be iterated directly in Liquid.
      // Interleave the resulting cards here so each configured category appears in the combined view.
      const sourceCards = [...root.querySelectorAll('[data-ritual-product]')];
      randomizeHero(root);
      randomizeStories(root);
      const giftTrack = root.querySelector('[data-gift-track]');
      const giftDots = root.querySelector('[data-gift-dots]');
      if (giftTrack && giftDots) {
        const giftCards = [...giftTrack.querySelectorAll('[data-gift-card]')];
        const dots = giftCards.map((card, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.setAttribute('aria-label', card.dataset.giftTitle);
          dot.setAttribute('aria-controls', giftTrack.id);
          dot.setAttribute('aria-pressed', String(index === 0));
          dot.addEventListener('click', () => {
            giftTrack.scrollTo({
              left: giftTrack.scrollLeft + card.getBoundingClientRect().left - giftTrack.getBoundingClientRect().left,
              behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
            });
          });
          giftDots.append(dot);
          return dot;
        });
        giftDots.hidden = giftCards.length < 2;
        let scrollFrame;
        giftTrack.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(() => {
            const edge = giftTrack.getBoundingClientRect().left;
            const distances = giftCards.map(card => Math.abs(card.getBoundingClientRect().left - edge));
            const activeIndex = distances.indexOf(Math.min(...distances));
            dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === activeIndex)));
          });
        }, { passive: true });
      }

      root.addEventListener('click', async event => {
        const button = event.target.closest('[data-ritual-add]');
        if (!button || button.disabled || !root.contains(button)) return;
        const card = button.closest('[data-ritual-product]');
        const picker = card.querySelector('[data-ritual-variant]');
        const status = card.querySelector('.ac-ritual__cart-status');
        if (picker && !picker.value) {
          picker.hidden = false;
          picker.focus();
          return;
        }
        const variantId = picker ? picker.value : button.dataset.variantId;
        const symbol = button.querySelector('span');
        const route = window.Shopify?.routes?.root || '/';
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        symbol.textContent = '…';
        status.textContent = '';
        try {
          const response = await fetch(`${route}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || button.dataset.errorMessage);
          symbol.textContent = '✓';
          status.textContent = button.dataset.addedMessage;
          // Refresh the existing cart UI without invoking its navigation/open behaviour.
          try {
            const cartResponse = await fetch(`${route}cart.js`);
            if (!cartResponse.ok) throw new Error('Cart refresh failed');
            const cart = await cartResponse.json();
            document.querySelectorAll('.js-cart-count').forEach(count => { count.textContent = cart.item_count; });
            const config = document.getElementById('cart-config');
            if (config && window.Shopify?.theme?.ajaxCart) {
              window.Shopify.theme.ajaxCart.updateView(JSON.parse(config.textContent), cart);
            }
          } catch (error) {
            // The item was added successfully; a refresh failure must not suggest retrying it.
            console.warn('Could not refresh cart display', error);
          }
        } catch (error) {
          symbol.textContent = '+';
          status.textContent = error.message || button.dataset.errorMessage;
        } finally {
          button.removeAttribute('aria-busy');
          button.disabled = false;
          setTimeout(() => { if (!button.disabled) symbol.textContent = '+'; }, 2000);
        }
      });
      const groupNames = root.dataset.sourceGroups?.split(',') || ['candles', 'diffusers', 'soaps'];
      const groups = groupNames.map(group =>
        sourceCards.filter(card => card.dataset.source === group));
      const cards = [];
      for (let index = 0; index < Math.max(...groups.map(group => group.length)); index += 1) {
        groups.forEach(group => { if (group[index]) cards.push(group[index]); });
      }
      root.querySelector('.ac-ritual__grid').append(...cards);
      const buttons = [...root.querySelectorAll('[data-ritual-filter]')];
      const more = root.querySelector('[data-ritual-more]');
      const status = root.querySelector('.ac-ritual__status');
      const desktopLimit = Number(root.dataset.limit) || 12;
      const mobileLimit = Number(root.dataset.mobileLimit) || 8;
      const pageSize = () => mobileLayout.matches ? mobileLimit : desktopLimit;
      let active = 'all';
      let visibleLimit = pageSize();
      function render(announce = true) {
        const matching = cards.filter(card => active === 'all' || card.dataset.groups.split(' ').includes(active));
        const visible = matching.slice(0, visibleLimit);
        cards.forEach(card => { card.hidden = !visible.includes(card); });
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ritualFilter === active)));
        more.hidden = matching.length <= visibleLimit;
        root.querySelector('.ac-ritual__empty').hidden = matching.length !== 0;
        if (announce) status.textContent = root.dataset.resultsTemplate.replace('__VISIBLE__', visible.length).replace('__TOTAL__', matching.length);
      }
      root.querySelector('.ac-ritual__filters')?.removeAttribute('hidden');
      buttons.forEach(button => button.addEventListener('click', () => {
        active = button.dataset.ritualFilter;
        visibleLimit = pageSize();
        render();
      }));
      more.addEventListener('click', () => {
        const previous = cards.filter(card => !card.hidden).length;
        visibleLimit += pageSize();
        render();
        // Move focus to the first revealed item, including when the button disappears.
        cards.filter(card => !card.hidden)[previous]?.querySelector('a')?.focus();
      });
      mobileLayout.addEventListener('change', () => {
        if (!root.isConnected) return;
        visibleLimit = pageSize();
        render(false);
      });
      render(false);
    });
  }
  function start() {
    init(document);
    initFooter();
    // Theme previews can replace section HTML without executing its script tags.
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {
        if (node.nodeType === 1) { init(node); initFooter(); }
      }));
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
